
export default {
  props: {
    product: Object,
    newest: Boolean,
  },
}
